module.exports = __webpack_public_path__ + "img/tu10.42b5e6e0.png";